/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIInteractionFeedbackSchema } from '../models/AIInteractionFeedbackSchema';
import type { SonioxConfigSchema } from '../models/SonioxConfigSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AiApi {
    /**
     * Get Soniox Config
     * Mint a short-lived Soniox temporary API key for browser dictation.
     * @returns SonioxConfigSchema OK
     * @throws ApiError
     */
    public static aiGetSonioxConfigPost(): CancelablePromise<SonioxConfigSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ai/soniox-config/',
        });
    }
    /**
     * Submit Interaction Feedback
     * Submit or update feedback for an AI interaction.
     * @returns any OK
     * @throws ApiError
     */
    public static aiSubmitInteractionFeedbackPut({
        interactionId,
        requestBody,
    }: {
        interactionId: string,
        requestBody: AIInteractionFeedbackSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/ai/interactions/{interaction_id}/feedback/',
            path: {
                'interaction_id': interactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
